import { createContext, useContext } from 'react';

export const SpecialDetailContext = createContext<{
  disableAnimation?: boolean;
  scrolledFromTop?: boolean;
}>({
  disableAnimation: false,
  scrolledFromTop: false,
});

export const useSpecialDetailContext = () => useContext(SpecialDetailContext);
